import { useSyncExternalStore } from 'react'
import { tokenStore } from './tokenStore'

export const useAuth = () => useSyncExternalStore(tokenStore.subscribe, tokenStore.getSnapshot, tokenStore.getSnapshot)
